import BookingResponse from "@/model/responses/BookingResponse";
import LoaderUtils from "@/utils/BaseUtils/LoaderUtils";
import BookingServices from "@/services/BookingServices";
import BookingRequest from "@/model/requests/BookingRequest";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
const bookingService = new BookingServices();

export const namespaced = true;

export const state = {
  bookingInfo: [],
  bookings: [],
  singleBooking: BookingResponse.readByCustomerId,
  profBookingInfo: [],
  bookingSuccess: false,
  cancelSuccess: false,
  activeBooking: "",
  cancelLoading: false,
  pendingReviews: [],
  bookingToBeReviewed: {},
  reviewSuccess: false
};

export const getters = {
  getBookings: state => {
    return state.bookings;
  },
  getBookingInfo: state => {
    return state.bookingInfo;
  },
  getSingleBooking: state => {
    return state.singleBooking;
  },
  getProfBookingInfo: state => {
    return state.profBookingInfo;
  }
};

export const mutations = {
  updateBookings: (state, payload) => {
    state.bookings = payload;
  },
  updateBookingInfo: (state, payload) => {
    state.bookingInfo = payload;
  },
  updateSingleBooking: (state, payload) => {
    state.singleBooking = payload;
  },
  updateProfBookingInfo: (state, payload) => {
    state.profBookingInfo = payload;
  },
  updateBookingSuccess: (state, payload) => {
    state.bookingSuccess = payload;
  },
  updateCancelSuccess: (state, payload) => {
    state.cancelSuccess = payload;
  },
  updateActiveBooking: (state, payload) => {
    state.activeBooking = payload;
  },
  updateCancelLoading: (state, payload) => {
    state.cancelLoading = payload;
  },
  updatePendingReviews: (state, payload) => {
    state.pendingReviews = payload;
  },
  updateBookingToBeReviewed: (state, payload) => {
    state.bookingToBeReviewed = payload;
  },
  updateReviewSuccess: (state, payload) => {
    state.reviewSuccess = payload;
  }
};

export const actions = {
  readBookings({ commit }) {
    let successAction = responseData => {
      commit("updateBookings", responseData.data);
    };
    return bookingService.readBooking(
      {},
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readBookingByCustomerId(
    { commit },
    payload = BookingRequest.readByCustomerId
  ) {
    let successAction = responseData => {
      commit("updateBookingInfo", responseData.data);
      commit("updateSingleBooking", responseData.data);
    };
    return bookingService.readByCustomerId(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readByBookingId({ commit }, payload = BookingRequest.readBy) {
    let successAction = responseData => {
      commit("updateSingleBooking", responseData.data);
    };
    return bookingService.readByBooking(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readBookingByProfessionalId(
    { commit },
    payload = BookingRequest.readByProfessionalId
  ) {
    let successAction = responseData => {
      commit("updateProfBookingInfo", responseData.data);
    };
    return bookingService.readByProfessionalId(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  createBooking({ commit }, payload = BookingRequest.create) {
    let successAction = () => {
      // commit("updateBookingSuccess", true);
    };
    return bookingService.createBooking(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  cancelBooking({ commit }, payload = BookingRequest.cancel) {
    commit("updateCancelLoading", true);

    let successAction = () => {
      commit("updateCancelLoading", false);
      commit("updateCancelSuccess", true);
      let bookingProfessionalId = StoreUtils.rootGetters("auth/getUserInfo")
        .professional.professionalId;
      StoreUtils.dispatch("booking/readBookingByProfessionalId", {
        bookingProfessionalId
      });
    };
    return bookingService.cancelBooking(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  rescheduleBooking({ commit }, payload = BookingRequest.reschedule) {
    let successAction = () => {};
    return bookingService.rescheduleBooking(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readPendingReviews({ commit }, payload = BookingRequest.readPendingReviews) {
    let successAction = responseData => {
      commit("updatePendingReviews", responseData.data);
    };
    return bookingService.readPendingReviews(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  updateReview({ commit }, payload = BookingRequest.updateReview) {
    let successAction = () => {
      commit("updateReviewSuccess", true);
      let bookingCustomerId = {
        bookingCustomerId: StoreUtils.rootGetters("auth/getUserInfo").customerId
      };
      StoreUtils.dispatch("booking/readBookingByCustomerId", bookingCustomerId);
    };
    return bookingService.updateReview(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  }
};
